import { createAsyncThunk } from "@reduxjs/toolkit";
// import api from "../../api/apiMeta";
import api from "../../api/apiPrakasak";

export const sync_meta_templates_thunk = createAsyncThunk(
  "threads/sync_meta_templates",
  async () => {
    return await api
      .get("sync_meta_templates")
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const get_all_templates_thunk = createAsyncThunk(
  "threads/get_all_templates",
  async () => {
    return await api
      .get("get_all_templates")
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const get_template_buttons_list_thunk = createAsyncThunk(
  "threads/get_template_buttons_list",
  async (templateId) => {
    return await api
      .get("get_template_buttons_list/" + templateId)
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const get_root_template_thunk = createAsyncThunk(
  "threads/get_root_template",
  async () => {
    return await api
      .get("get_root_template")
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const set_root_template_thunk = createAsyncThunk(
  "threads/set_root_template",
  async (templateId) => {
    console.log(">>>", templateId);
    return await api
      .get("set_root_template/" + templateId)
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const get_mediaurl_by_templateid_thunk = createAsyncThunk(
  "threads/get_mediaurl_by_templateid",
  async (templateId) => {
    return await api
      .get("get_mediaurl_by_templateid/" + templateId)
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const set_mediaurl_by_templateid_thunk = createAsyncThunk(
  "threads/set_mediaurl_by_templateid",
  async ({ templateId, mediaUrl }) => {
    return await api
      .post("set_mediaurl_by_templateid/" + templateId, { mediaUrl })
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);

export const create_thread_thunk = createAsyncThunk(
  "threads/create_thread",
  async (body) => {
    return await api
      .post("create_thread", body)
      .then((response) => response.data)
      .catch((error) => {
        console.error(">>> Axios Error:", error);
        return { status: error.code, message: error.message };
      });
  }
);
